/**
 * Muscle Grenade — countdown Mes de la Patria 2026
 * Targets 18 Sep 2026, then the holiday window through 21 Sep.
 */
(function () {
  'use strict';

  var PATRIA = new Date('2026-09-18T00:00:00-03:00').getTime();
  var HOLIDAY_END = new Date('2026-09-21T23:59:59-03:00').getTime();
  var MONTH_END = new Date('2026-09-30T23:59:59-03:00').getTime();

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function tick(root) {
    var now = Date.now();
    var target = PATRIA;
    var label = root.querySelector('[data-mg-count-label]');
    var done = root.querySelector('[data-mg-count-done]');

    if (now < PATRIA) {
      if (label) label.textContent = 'Faltan para el 18 de septiembre';
    } else if (now < HOLIDAY_END) {
      target = HOLIDAY_END;
      if (label) label.textContent = 'Ofertas del 18 terminan en';
    } else if (now < MONTH_END) {
      target = MONTH_END;
      if (label) label.textContent = 'Últimos días del Mes de la Patria';
    } else {
      if (done) {
        done.hidden = false;
        root.querySelector('[data-mg-count-grid]').hidden = true;
      }
      if (label) label.textContent = 'Campaña cerrada';
      return;
    }

    var diff = Math.max(0, target - now);
    var d = Math.floor(diff / 86400000);
    var h = Math.floor((diff % 86400000) / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    var set = function (key, val) {
      var el = root.querySelector('[data-mg-count="' + key + '"]');
      if (el) el.textContent = pad(val);
    };
    set('d', d);
    set('h', h);
    set('m', m);
    set('s', s);
  }

  function start() {
    var nodes = document.querySelectorAll('[data-mg-countdown]');
    if (!nodes.length) return;
    nodes.forEach(function (node) {
      tick(node);
      setInterval(function () {
        tick(node);
      }, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
